import { render, staticRenderFns } from "./AlertSettings.page.vue?vue&type=template&id=63bfa7fb&scoped=true"
import script from "./AlertSettings.page.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertSettings.page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertSettings.page.vue?vue&type=style&index=0&id=63bfa7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfa7fb",
  null
  
)

export default component.exports